import { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { Tabs, Tab, Box, Paper, AccordionSummary } from "@mui/material";
import MDTypography from "components/MDTypography";
import TabTennant from "./tabs/TabTennant";
import TabUser from "./tabs/TabUser";

function Overview() {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (index) => {
    setTabIndex(index);
  }

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && children}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  return (
    <DashboardLayout>
      <DashboardNavbar customTitle={"Administração"} />
      <Paper sx={{
        top: 50,
        borderRadius: "12px",
        padding: "60px 10px 12px 10px",
        position: "relative",
        marginBottom: 10,
      }}>
        <Box>
          <AccordionSummary
            aria-controls="opcoes-content"
            id="opcoes-header"
            sx={{
              position: "absolute",
              width: "98%",
              top: -25,
              left: 17,
              background: "linear-gradient(195deg, #49a3f1, #1A73E8)",
              minHeight: "72px",
              borderRadius: "6px",
              marginBottom: 2,
              px: 2,

              "& .MuiAccordionSummary-content": {
                alignItems: "center",
              },

              "&.Mui-expanded": {
                minHeight: "72px",
              },

              "& .MuiAccordionSummary-content.Mui-expanded": {
                margin: "12px 0",
              },
            }}
          >
            <MDTypography variant="h6" color="white" fontWeight="medium">
              Administração
            </MDTypography>
          </AccordionSummary>
          <Box>
            <Tabs value={tabIndex} onChange={(event, newValue) => handleTabChange(newValue)} aria-label="basic tabs example">
              <Tab label="Empresas" {...a11yProps(0)} />
              <Tab label="Usuários" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={tabIndex} index={0}>
            <TabTennant />
          </CustomTabPanel>
          <CustomTabPanel value={tabIndex} index={1}>
            <TabUser />
          </CustomTabPanel>
        </Box>
      </Paper>
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
